// extracted by mini-css-extract-plugin
export var buttonGhost = "button-module--buttonGhost--g8Rm2";
export var buttonPrimary = "button-module--buttonPrimary--ga8BV";
export var buttonSecondary = "button-module--buttonSecondary--DcCRI";
export var buttonTertiary = "button-module--buttonTertiary--ouJZO";